import React from "react";
import { Input } from "antd";
const { TextArea } = Input;

function CustomTextArea({
  label,
  placeholder,
  inputClassname,
  id,
  value,
  onChange,
  labelClass,
  maxLength = 200,
  wrapperClass,
}) {
  return (
    <div
      className={`flex flex-col w-full gap-1 ${wrapperClass ? wrapperClass : ""}`}
    >
      {label && (
        <label className={`input-label ${labelClass}`} htmlFor={id}>
          {label}
        </label>
      )}
      <TextArea
        rows={4}
        value={value}
        id={id}
        className={`text-area ${inputClassname}`}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    </div>
  );
}

export default CustomTextArea;
